import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { items } from "../../../constants/sidebar_data";
import logo from "../../../assets/images/logo/Corporate-logo.jpg";

type ISideNav = {
  open: boolean;
};

const SideNav: React.FC<ISideNav> = ({ open }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <aside
      className={`bg-primary-500 h-screen transition-all ease-in-out duration-200 relative ${
        open ? "px-2 w-16" : "px-3 w-64"
      } `}
    >
      <div
        className={`w-full h-16 flex items-center py-3 mb-9 border-b border-b-customgreen/30 ${open && "justify-center"}`}
      >
        <div className="flex items-center gap-2">
          <img
            src={logo}
            alt="logo"
            className="w-9 h-auto aspect-square cursor-pointer rounded-lg"
            onClick={() => navigate("/")}
          />
          <div
            className={`flex flex-col text-sm text-white capitalize transition-opacity duration-150 whitespace-nowrap ${!open && "px-3"} ${
              open ? "hidden" : "block"
            }`}
          >
            <span className="font-semibold">Corperate Setup</span>
            <span className="text-xs">Administrator</span>
          </div>
        </div>
      </div>

      <nav className="grid gap-3 overflow-hidden">
        {items.map((item) => {
          const isActive =
            location.pathname === item.link ||
            location.pathname.startsWith(item.link + "/");
          return (
            <NavLink
              key={item.key}
              to={item.link}
              className={`text-lg transition-all duration-200 rounded-md flex items-center p-2 gap-3 ${open && "justify-center"} ${!open && "px-3"}
              ${
                isActive
                  ? "bg-white text-primary-700 hover:!text-primary-700"
                  : "text-white hover:bg-primary-600 hover:text-gray-200"
              }`}
            >
              {item.icon && (
                <div
                  className={`flex items-center justify-center  ${open && "w-6"}`}
                >
                  <item.icon size={25} />
                </div>
              )}
              <span
                className={`font-medium transition-opacity duration-150 whitespace-nowrap ${
                  open ? "hidden" : "block"
                }`}
              >
                {item.title}
              </span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
};

export default SideNav;
